import React from 'react'
import { useLocation, Link } from 'react-router-dom'

const Navbar = () => {

    const location = useLocation();

    return (
      <div className="container">
        <nav id="navbar">
          <div className="container">
          <Link to='/' className='brand-logo'>Aman Bhardwaj</Link>
          <Link to="/"></Link>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/work" className={location.pathname === '/work' ? 'current' : ''}>Work</Link></li>
            <li><Link to="/about" className={location.pathname === '/about' ? 'current' : ''}>About</Link></li>
          </ul>
          </div>
        </nav>
      </div>
    )
}

export default Navbar
